import dao from '../../../dao/smbpartner/dashboardDao';

const QUERY_STATS = 'pages/partner/home/QUERY_STATS';
const QUERY_STATS_SUCCESS = 'pages/partner/home/QUERY_STATS_SUCCESS';

const initialState = {
  isLoaded: true,
  stats: {},
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case QUERY_STATS:
      return {
        ...state,
        isLoaded: false,
      };
    case QUERY_STATS_SUCCESS:
      return {
        ...state,
        stats: {
          ...state.stats,
          ...action.json,
        },
        isLoaded: true,
      };
    default:
      return {
        ...state,
      };
  }
};

export function queryStats() {
  return dispatch => {
    dispatch({type: QUERY_STATS});
    return dao.queryStats().then(json => {
      return dispatch({type: QUERY_STATS_SUCCESS, json});
    });
  };
}
